"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const RowModalChooseTreatment_vue_1 = __importDefault(require("./components/RowModalChooseTreatment.vue"));
const BreadcrumbsModal_vue_1 = __importDefault(require("./components/BreadcrumbsModal.vue"));
const floating_vue_1 = require("floating-vue");
const SetDatePayload_1 = __importDefault(require("../../Abstract/models/SetDatePayload"));
const AssignationPayload_1 = __importDefault(require("../../Abstract/models/AssignationPayload"));
let ModalDetailsProcess = class ModalDetailsProcess extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.resetInput = false;
        this.datesFake = ['09MAY2023', ' 01DEC1995', '21JUN2003', '09ENE2020'];
    }
    get sampleGroupDate() {
        return this.currentTreatment.times[this.currentTime].date || new Date();
    }
    set sampleGroupDate(newDate) {
        newDate.setHours(12, 0, 0, 0);
        this.currentTreatment.times[this.currentTime].date = newDate;
    }
    resetSetDateAsyncResponse() {
        this.$emit('resetSetDateAsyncResponse');
    }
    updateDate(val) {
        this.sampleGroupDate = val;
    }
    dismissModal() {
        this.$emit('dismissModalDetailsProcess');
    }
    deployListCodes() {
        const data = new AssignationPayload_1.default({
            'location_id': this.location.id,
            'treatment_id': this.currentTreatment.meta.treatmentID,
            'time': this.currentTime,
            'samples': []
        });
        this.$emit('deployListCodes', data);
    }
    deployMarkListCodes() {
        const data = new AssignationPayload_1.default({
            'location_id': this.location.id,
            'treatment_id': this.currentTreatment.meta.treatmentID,
            'time': this.currentTime,
            'samples': []
        });
        this.$emit('deployMarkListCodes', data);
    }
    deployAssignation() {
        this.$emit('deployAssignation');
    }
    markDetailInfo() {
        const data = new SetDatePayload_1.default({
            'location_id': this.location.id,
            'treatment_id': this.currentTreatment.meta.treatmentID,
            'time': this.currentTime,
            'date': this.sampleGroupDate
        });
        this.$emit('markDetailInfo', data);
    }
    formatStage(text) {
        return this.separateByCapitalLetters(this.textUpperCase(text));
    }
    textUpperCase(text) {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
    separateByCapitalLetters(text) {
        return text.replace(/([A-Z])/g, ' $1').trim();
    }
    extractControlTypeTreatment() {
        const objetosFiltrados = this.treatments.filter((objeto) => objeto.meta.control === true);
        return objetosFiltrados;
    }
    // Selects
    modelEmitTimes(val) { }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: -1 })
], ModalDetailsProcess.prototype, "currentTime", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ModalDetailsProcess.prototype, "currentTreatment", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], ModalDetailsProcess.prototype, "location", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], ModalDetailsProcess.prototype, "treatments", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], ModalDetailsProcess.prototype, "setDateAsyncResponse", void 0);
ModalDetailsProcess = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Modal: bmk_ui_framework_1.Modal,
            SelectField: bmk_ui_framework_1.SelectField,
            List: bmk_ui_framework_1.List,
            ListItem: bmk_ui_framework_1.ListItem,
            RowModalChooseTreatment: RowModalChooseTreatment_vue_1.default,
            BreadcrumbsModal: BreadcrumbsModal_vue_1.default,
            Select: bmk_ui_framework_1.Select,
            Separator: bmk_ui_framework_1.Separator,
            WorldIcon: bmk_ui_framework_1.WorldIcon,
            ShipmentIcon: bmk_ui_framework_1.ShipmentIcon,
            ListIcon: bmk_ui_framework_1.ListIcon,
            PairIcon: bmk_ui_framework_1.PairIcon,
            Dropdown: floating_vue_1.Dropdown,
            Toasts: bmk_ui_framework_1.Toasts,
            DateStylized: bmk_ui_framework_1.DateStylized,
            CheckAloneIcon: bmk_ui_framework_1.CheckAloneIcon,
            LoaderBuild: bmk_ui_framework_1.LoaderBuild,
            Button: bmk_ui_framework_1.Button,
            DatePickerField: bmk_ui_framework_1.DatePickerField
        },
    })
], ModalDetailsProcess);
exports.default = ModalDetailsProcess;
